import React from 'react';
import { Modal } from '@vimily/bonjoro-ui-components-v2/Modal';
import { assetUrl } from '~/helpers';
import { PricingSelectorType } from '../../NewBilling/Pages/Pricing';
import Card from '~/App/Components/Cards/Card';
import { HorizontalDivider } from '../../NewBilling/Components/Common/HorizontalDivider';
import { CustomerSupportPanel } from '../../NewBilling/Components/Subscription/CustomerSupportPanel';
import { useZiggy } from '~/react-hooks/use-ziggy';
import { StartUpgradeModalFlowProps } from '~/App/Components/Modals/UpgradeModalFlow';

export interface LegacyChangePlanModalModalProps
  extends Pick<StartUpgradeModalFlowProps, 'onBeforeRedirect'> {
  open: boolean;
  onModalClose: () => void;
}

export interface NewPlanOptionProps
  extends Pick<LegacyChangePlanModalModalProps, 'onBeforeRedirect'> {
  icon: React.ReactNode;
  title: string;
  url: string;
}

function NewPlanOption({
  icon,
  title,
  url,
  onBeforeRedirect,
}: NewPlanOptionProps) {
  const onClick = async () => {
    await onBeforeRedirect?.();

    window.location.href = url;
  };

  return (
    <Card
      className='w-[215px] h-[152px] p-5 flex flex-col items-center space-y-3.5'
      onClick={onClick}
    >
      <div>{icon}</div>
      <span className='text-center'>{title}</span>
    </Card>
  );
}

function ServiceLogo({ src }: { src: string }) {
  return (
    <div className='w-[50px] h-[50px] flex justify-center border border-solid border-neutral-300 rounded'>
      <img className='w-7' src={src} />
    </div>
  );
}

export default function LegacyChangePlanModal({
  open,
  onBeforeRedirect,
  onModalClose,
}: LegacyChangePlanModalModalProps) {
  const { route } = useZiggy();

  const tmLogo = (
    <ServiceLogo src={assetUrl('assets/images/icons/nav/tm-color.svg')} />
  );
  const vmLogo = (
    <ServiceLogo src={assetUrl('assets/images/icons/nav/vm-color.svg')} />
  );

  return (
    <Modal
      open={open}
      onModalClose={onModalClose}
      className='max-w-[500px] md:max-w-[750px] overflow-y-auto'
    >
      <h1 className='self-center v2-text-neutral-900 text-xl pt-0 mb-5'>
        Changing plan for legacy users
      </h1>

      <p className='v2-text-neutral-900 text-base text-center mb-5'>
        As of September 2023, we have split pricing for Video messaging and
        Testimonials. Please select which products would you like to continue
        using below.
      </p>

      <div className='flex flex-col mb-5 items-center space-y-5 md:flex-row md:space-y-0 md:space-x-5'>
        <NewPlanOption
          icon={
            <div className='flex space-x-5'>
              {vmLogo}
              {tmLogo}
            </div>
          }
          title='Video messaging & Testimonials'
          url={route(
            'billing::pricing',
            { select: PricingSelectorType.Both },
            false
          )}
          onBeforeRedirect={onBeforeRedirect}
        />
        <NewPlanOption
          icon={vmLogo}
          title='Video messaging only'
          url={route(
            'billing::pricing',
            { select: PricingSelectorType.VideoMessaging },
            false
          )}
          onBeforeRedirect={onBeforeRedirect}
        />
        <NewPlanOption
          icon={tmLogo}
          title='Testimonials only'
          url={route(
            'billing::pricing',
            { select: PricingSelectorType.Testimonials },
            false
          )}
          onBeforeRedirect={onBeforeRedirect}
        />
      </div>
      <HorizontalDivider className='mb-5' />
      <CustomerSupportPanel className='shadow-[unset]' />
    </Modal>
  );
}
